import { AnimatePresence, motion } from 'framer-motion'

import { ScheduleListCard, ScheduleListCardSkeleton } from '@apps-common/apps/portal/pages/units/pages/manage/pages/schedules/components'
import { NoResultsAddCard } from '@apps-common/components/common'
import { ProductNotSupportedCard } from '@apps-common/components/common/ProductNotSupportedCard'
import { motionFadeIn } from '@apps-common/config/motion-variants'
import { CONTROL_TRIGGER_SCHEDULE_ALLOWED_PRODUCTS } from '@apps-common/config/product-codes'
import { UNIT_STATUS_CANCELLED } from '@apps-common/config/unit-filter'
import { IUnitScheduledModel } from '@apps-common/types/portal/unit-scheduled'
import { useScheduleModifyModal } from '../hooks/useScheduleModifyModal'

interface IProps {
  status: string
  unitId: string
  productId: string
  loading: boolean
  data: IUnitScheduledModel[]
}

export const Schedules: React.FC<IProps> = ({ status, unitId, productId, loading, data }) => {
  const { present } = useScheduleModifyModal({
    status,
    unitId,
    productId,
    scheduleId: undefined
  })

  return (
    <ProductNotSupportedCard
      bgClasses='bg-surface text-text border border-border'
      productId={productId}
      message='This product does not support schedules.'
      allowedProductIds={CONTROL_TRIGGER_SCHEDULE_ALLOWED_PRODUCTS}
    >
      <div className='grid sm:grid-cols-2 gap-[20px] max-w-[1000px]'>
        <AnimatePresence mode='popLayout'>
          {loading &&
            Array.from(Array(2).keys()).map((s, i) => (
              <motion.div key={`schedule-list-card-skeleton-${i}`} {...motionFadeIn(0.2)}>
                <ScheduleListCardSkeleton />
              </motion.div>
            ))}
          {!loading && data && data.length === 0 && (
            <motion.div key='no-schedules-create-button' {...motionFadeIn(0.2)}>
              <NoResultsAddCard
                message='Add a new device schedule.'
                disabled={loading || status === UNIT_STATUS_CANCELLED.value}
                callback={() => present()}
              />
            </motion.div>
          )}
          {!loading &&
            data &&
            data.length > 0 &&
            data.map((s, i) => (
              <motion.div key={`schedule-list-card-${i}`} {...motionFadeIn(0.2)}>
                <ScheduleListCard unitStatus={status} unitId={unitId} productId={productId} schedule={s} />
              </motion.div>
            ))}
        </AnimatePresence>
      </div>
    </ProductNotSupportedCard>
  )
}
